// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-7903a85f] .type-description{font-size:11px}label.radio[data-v-7903a85f]{font-size:16px}.custom-permissions[data-v-7903a85f]{display:grid;grid-template-columns:1fr 1fr 1fr}.custom-permissions.two-column[data-v-7903a85f]{grid-template-columns:1fr 1fr}.custom-permissions[data-v-7903a85f] .checkbox-label{margin-right:0}", ""]);
// Exports
module.exports = exports;
